import { TrackRecordModel } from "../api/models";

export function hasTrackRecordUnreviewedRecord(records: TrackRecordModel[]) {
  if (records && records.length > 0) {
    return records.some((record) => record.status === "Unreviewed");
  }

  return false;
}

export function managerHasTrackRecord(trackRecords: TrackRecordModel[]) {
  return Array.isArray(trackRecords) && trackRecords.length > 0;
}
